<template>
    <div style="display: flex">
        <v-menu
            v-model="closeProfile"
            offset-y
            origin="right top"
            left
            content-class="language-dropdown no-stripe"
            transition="slide-y-transition"
            nudge-top="-10"
            class="user-block-wrap"
        >
            <v-btn icon large slot="activator" @mouseup.left="$emit('closeNotifs')">
                <img
                    :src="showErrorImg ? errorImg : profilePhoto"
                    :key="updatePhoto"
                    alt="avatar"
                    height="40"
                    width="40"
                    class="img-responsive rounded-circle"
                    @error="showErrorImg = true"
                />
            </v-btn>
            <div class="dropdown-content">
                <v-card>
                    <v-list class="pt-3">
                        <v-list-tile avatar>
                            <v-list-tile-avatar class="clickable">
                                <img
                                    :src="showErrorImg ? errorImg : profilePhoto"
                                    :key="updatePhoto"
                                    :alt="current_user ? current_user.first_name : 'Avatar'"
                                    @error="showErrorImg = true"
                                    @mouseup.left="$refs.croppa.chooseFile()"
                                />
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title class="font-weight-medium">{{
                                    current_user ? (current_user.combined_name != null ? current_user.combined_name : current_user.first_name) : ""
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ current_user ? current_user.job_title : "" }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <v-divider></v-divider>

                    <v-list v-for="item in filteredUserLinks" :key="item.title">
                        <v-list-tile
                            :to="item.name ? { name: item.name } : ''"
                            @click="
                                loggedInUser != null && item.method && item.method == 'logoutUser'
                                    ? switchBackMainUser()
                                    : item.method && item.method == 'logoutUser'
                                    ? logoutUser()
                                    : item.method && item.method == 'goToYoutube'
                                    ? goToYoutube()
                                    : ''
                            "
                            v-if="!item.permission || hasPerm(item.permission)"
                        >
                            <v-list-tile-action>
                                <v-icon :class="item.class">{{ item.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ loggedInUser != null && item.title == "lang.logOut" ? "Switch" : $t(item.title) }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                    <v-divider class="mb-1"></v-divider>
                    <div class="small fs-12 text-center pb-1">Build Version {{ version }}</div>
                </v-card>
            </div>
        </v-menu>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
    </div>
</template>

<script>
import { getCurrentAppLayout } from "Helpers/helpers";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            version: null,
            closeProfile: false,
            newFile: {
                photo_file: "",
            },
            updatePhoto: 0,
            userLinks: [
                {
                    title: "lang.userProfile",
                    class: "mr-3 primary--text",
                    icon: "person_outline",
                    name: "users_my_profile",
                    customer_only: "0",
                    permission: "",
                },
                // {
                //     title: "lang.licadas_youtube",
                //     class: "mr-3 primary--text",
                //     icon: "play_circle_outline",
                //     method: "goToYoutube",
                //     customer_only: "0",
                //     permission: "",
                // },
                {
                    title: "lang.configuration",
                    class: "mr-3 primary--text",
                    icon: "tune",
                    name: "configuration",
                    customer_only: "1",
                    permission: "configuration.read",
                },
                // {
                // 	title: 'lang.userOrganizations',
                // 	class: 'mr-3 primary--text',
                // 	icon: 'corporate_fare',
                // 	path: '/users/my_organizations',
                // 	customer_only: '1'
                // },
                // {
                // 	title: 'lang.subscriptions',
                // 	class: 'mr-3 primary--text',
                // 	icon: 'autorenew',
                // 	path: '/users/my_subscriptions',
                // 	customer_only: '1'
                // },
                {
                    title: "lang.logOut",
                    class: "mr-3 error--text",
                    icon: "logout",
                    method: "logoutUser",
                    customer_only: "0",
                    permission: "",
                },
            ],
            showErrorImg: false,
            errorImg: AppConfig.baseApiUrl + "/public/users/default.png",
            loggedInUser: null,
        };
    },
    // mounted() {

    //     console.log(document.documentElement.dataset.buildTimestampUtc);
    // },
    computed: {
        filteredUserLinks() {
            // return this.userLinks.filter((link) => link.customer_only == 0 || (this.currUserField("slug") == "employee" && link.customer_only == "1"));
            return this.userLinks.filter((link) => link.permission == "" || this.hasPerm(link.permission));
        },
        profilePhoto() {
            return this.current_user ? this.current_user.photo_thumb : "";
        },
    },
    methods: {
        logoutUser() {
            this.$store.dispatch("logoutUser", { toLogin: true });
        },
        getMenuLink(path) {
            return "/" + getCurrentAppLayout(this.$router) + path;
        },
        handleFileUpload(file) {
            this.newFile.photo_file = file;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("uploadMyPhoto", {
                    url: "me/photo",
                    dataProperty: "person",
                    commit: true,
                    localStorage: true,
                    body: this.newFile,
                })
                .then((data) => {})
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
        switchBackMainUser() {
            let drawer = localStorage.getItem("original_drawer");
            let dashboard_original_layout = localStorage.getItem("original_dashboard_original_layout");
            let dashboard_layout = localStorage.getItem("original_dashboard_layout");
            let token = $cookies.get("original_token");
            let current_user = localStorage.getItem("original_current_user");

            localStorage.setItem("drawer", drawer);
            localStorage.setItem("dashboard_original_layout", dashboard_original_layout);
            localStorage.setItem("dashboard_layout", dashboard_layout);
            $cookies.set("token", token, null, null, null, true, "Strict");
            localStorage.setItem("current_user", current_user);

            localStorage.removeItem("original_drawer");
            localStorage.removeItem("original_dashboard_original_layout");
            localStorage.removeItem("original_dashboard_layout");
            $cookies.remove("original_token");
            localStorage.removeItem("original_current_user");
            location.reload();
        },
        goToYoutube() {
            window.open("https://www.youtube.com/@licadas", "_blank");
        },
    },
    mounted() {
        this.version = document.documentElement.dataset.buildTimestampUtc;
        if (localStorage.getItem("original_current_user") !== null && this.$bp.smAndDown) {
            this.loggedInUser = JSON.parse(localStorage.getItem("current_user"));
        }
    },
};
</script>
